module.exports = __webpack_public_path__ + "content/dd4b4aa2d3d7951dffb4f476768c5127.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/logo-pg-small.png
// module id = 340
// module chunks = 0